// ============================================================================
// PORTUGUESE TRANSLATIONS - CHAPTER 7: CARTAS E APOCALIPSE
// ============================================================================
// Níveis 79-91 (13 níveis, 39 perguntas)

export const chapter7Translations = {
  name: "Cartas e Apocalipse",
  description: "Quem vencer herdará todas estas coisas... A sabedoria do alto santifica o entendimento",
  
  spiritualWisdom: {
    principle: "A sabedoria do alto santifica o entendimento e vivifica o espírito",
    scripture: "Se algum de vós tem falta de sabedoria, peça-a a Deus (Tiago 1:5)",
    application: "Cada carta apostólica e cada visão do Apocalipse enriquece nossa compreensão e fortalece nossa esperança"
  },
  
  levels: {
    79: {
      name: "Prisão em Jerusalém",
      challenge: "Estou pronto não só para ser preso, mas também para morrer em Jerusalém...",
      easy: {
        question: "Onde Paulo foi preso na última visita?",
        options: ["Antioquia", "Éfeso", "Jerusalém", "Corinto"],
        correctAnswer: 2,
        hint: "A cidade santa que frequentemente perseguia os profetas",
        funFact: "🏛️ Jerusalém: lugar de glória e sofrimento para todos os servos de Deus!"
      },
      medium: {
        question: "Do que os judeus acusaram Paulo?",
        options: [
          "Roubo do Templo",
          "Profanação do Templo ao introduzir gentios",
          "Blasfêmia contra Moisés",
          "Rebelião contra Roma"
        ],
        correctAnswer: 1,
        hint: "Acusação ligada à universalidade do Evangelho",
        funFact: "⛪ Ironia: Paulo acusado de profanar o Templo que ele profundamente honrava!"
      },
      hard: {
        question: "Como Paulo transformou sua prisão em oportunidade?",
        options: [
          "Fugiu",
          "Testemunhou perante as autoridades e escreveu suas epístolas",
          "Ficou em silêncio",
          "Negociou sua libertação"
        ],
        correctAnswer: 1,
        hint: "Trata-se de transformar a provação em testemunho",
        funFact: "⛓️ Correntes físicas, liberdade espiritual - poderoso testemunho de fé!"
      }
    },
    
    80: {
      name: "Diante do Governador Félix",
      challenge: "Enquanto discorria sobre justiça, domínio próprio e juízo vindouro...",
      easy: {
        question: "Diante de qual governador Paulo testemunhou sua fé?",
        options: ["Pilatos", "Félix", "Festo", "Gálio"],
        correctAnswer: 1,
        hint: "Governador conhecido por sua ganância",
        funFact: "⚖️ Félix esperava um suborno - corrupção diante da integridade!"
      },
      medium: {
        question: "Qual foi a reação de Félix à mensagem de Paulo?",
        options: [
          "Converteu-se",
          "Tremeu de medo",
          "Zombou",
          "Ficou indiferente"
        ],
        correctAnswer: 1,
        hint: "Consciência perturbada pela verdade",
        funFact: "😰 Até os corruptos tremem diante da verdade divina - consciência universal!"
      },
      hard: {
        question: "Por que Félix manteve Paulo preso por dois anos?",
        options: [
          "Para protegê-lo",
          "Por interesse político e esperança de corrupção",
          "Por esquecimento",
          "Por convicção"
        ],
        correctAnswer: 1,
        hint: "Trata-se de cálculos políticos e pessoais",
        funFact: "🏛️ Justiça humana corrupta vs justiça divina perfeita - contraste marcante!"
      }
    },

    81: {
      name: "Apelo a César",
      challenge: "Apelo para César!",
      easy: {
        question: "Qual direito Paulo invocou para evitar julgamento em Jerusalém?",
        options: [
          "Direito de asilo",
          "Apelo a César (cidadão romano)",
          "Direito de fuga",
          "Proteção diplomática"
        ],
        correctAnswer: 1,
        hint: "Privilégio de sua cidadania romana",
        funFact: "🏛️ Cidadania romana: passaporte divino para levar o Evangelho a Roma!"
      },
      medium: {
        question: "Diante de quem Paulo testemunhou antes de partir?",
        options: [
          "O Sinédrio",
          "O rei Agripa e Berenice",
          "Soldados romanos",
          "A multidão judaica"
        ],
        correctAnswer: 1,
        hint: "Realeza herodiana judaizada",
        funFact: "👑 De pastor de ovelhas ao palácio real - elevação divina de Paulo!"
      },
      hard: {
        question: "Como Deus usa os sistemas humanos para seus planos?",
        options: [
          "Ignora-os",
          "Usa-os providencialmente para realizar seus desígnios",
          "Destrói-os",
          "Sempre se opõe"
        ],
        correctAnswer: 1,
        hint: "Trata-se da soberania divina sobre a história",
        funFact: "🌐 A justiça romana torna-se veículo do Evangelho - notável providência!"
      }
    },

    82: {
      name: "Naufrágio em Malta",
      challenge: "Não temas, Paulo; é necessário que compareças perante César...",
      easy: {
        question: "Em qual ilha Paulo naufragou?",
        options: ["Creta", "Chipre", "Malta", "Sicília"],
        correctAnswer: 2,
        hint: "Pequena ilha ao sul da Sicília",
        funFact: "🏝️ Malta: parada forçada torna-se missão frutífera - desvios divinos!"
      },
      medium: {
        question: "Qual milagre Paulo realizou em Malta?",
        options: [
          "Acalmou a tempestade",
          "Curou o pai de Públio e outros doentes",
          "Multiplicou comida",
          "Ressuscitou um morto"
        ],
        correctAnswer: 1,
        hint: "Múltiplas curas na ilha",
        funFact: "🏥 Paulo: de náufrago a médico milagroso - reputação divina!"
      },
      hard: {
        question: "Como este naufrágio ilustra a fidelidade divina?",
        options: [
          "Acidentes acontecem",
          "Deus protege e cumpre suas promessas apesar dos obstáculos",
          "Paulo teve sorte",
          "Era evitável"
        ],
        correctAnswer: 1,
        hint: "Trata-se da fidelidade divina às promessas",
        funFact: "⛈️ Tempestade, naufrágio, serpente: nada detém o plano divino para Paulo!"
      }
    },

    83: {
      name: "Paulo em Roma",
      challenge: "Permaneceu dois anos inteiros numa casa que alugara...",
      easy: {
        question: "Em que condições Paulo viveu em Roma?",
        options: [
          "Em prisão fechada",
          "Em prisão domiciliar",
          "Em total liberdade",
          "No exílio"
        ],
        correctAnswer: 1,
        hint: "Liberdade relativa sob vigilância",
        funFact: "🏠 Casa-prisão torna-se centro missionário - liberdade nas correntes!"
      },
      medium: {
        question: "O que Paulo fez durante seus dois anos em Roma?",
        options: [
          "Descansou",
          "Ensinou e escreveu suas epístolas",
          "Preparou sua defesa",
          "Fez turismo"
        ],
        correctAnswer: 1,
        hint: "Ministério intenso apesar das correntes",
        funFact: "✍️ Epístolas da prisão: Efésios, Filipenses, Colossenses, Filemom!"
      },
      hard: {
        question: "Como Paulo terminou seu ministério segundo a tradição?",
        options: [
          "Morreu de doença",
          "Foi decapitado sob Nero por volta de 67 d.C.",
          "Morreu de velhice",
          "Desapareceu misteriosamente"
        ],
        correctAnswer: 1,
        hint: "Martírio sob o imperador louco",
        funFact: "⚔️ 'Combati o bom combate, terminei a carreira' - vitória final!"
      }
    },

    84: {
      name: "A Epístola aos Romanos",
      challenge: "Não me envergonho do Evangelho; ele é o poder de Deus para a salvação...",
      easy: {
        question: "Qual epístola desenvolve mais a doutrina da salvação pela fé?",
        options: ["1 Coríntios", "Gálatas", "Romanos", "Efésios"],
        correctAnswer: 2,
        hint: "A 'catedral' teológica de Paulo",
        funFact: "🏛️ Romanos: obra-prima teológica que converteu Agostinho e Lutero!"
      },
      medium: {
        question: "Segundo Romanos, como o homem é justificado diante de Deus?",
        options: [
          "Por suas boas obras",
          "Pela fé somente, sem as obras",
          "Por sacrifícios",
          "Pela tradição"
        ],
        correctAnswer: 1,
        hint: "Princípio fundamental da Reforma",
        funFact: "⚖️ 'O justo viverá pela fé' - revolução espiritual de Paulo!"
      },
      hard: {
        question: "Qual é o alcance universal desta epístola?",
        options: [
          "Concerne apenas aos romanos",
          "Expõe o plano de salvação para toda a humanidade",
          "Critica apenas Roma",
          "Está obsoleta"
        ],
        correctAnswer: 1,
        hint: "Trata-se do plano universal de salvação",
        funFact: "🌍 Evangelho = poder de Deus para todos: judeus e gregos - universalidade total!"
      }
    },

    85: {
      name: "O Hino do Amor - 1 Coríntios 13",
      challenge: "Ainda que eu falasse as línguas dos homens e dos anjos, se não tivesse amor...",
      easy: {
        question: "Qual capítulo da Bíblia é chamado 'o hino do amor'?",
        options: [
          "1 Coríntios 12",
          "1 Coríntios 13",
          "1 João 4",
          "Romanos 8"
        ],
        correctAnswer: 1,
        hint: "O capítulo central de 1 Coríntios",
        funFact: "💝 Capítulo mais lido em casamentos - definição perfeita do amor!"
      },
      medium: {
        question: "O que Paulo diz sobre a duração do amor?",
        options: [
          "O amor passa com o tempo",
          "O amor nunca falha",
          "O amor depende das circunstâncias",
          "O amor é temporário"
        ],
        correctAnswer: 1,
        hint: "Eternidade do amor divino",
        funFact: "♾️ Só o amor atravessa a morte e a eternidade - valor supremo!"
      },
      hard: {
        question: "Por que Paulo coloca o amor acima dos dons espirituais?",
        options: [
          "Os dons são maus",
          "O amor dá sentido e valor a todo o resto",
          "O amor é mais fácil",
          "Os dons dividem"
        ],
        correctAnswer: 1,
        hint: "Trata-se do motor e do sentido de todo serviço",
        funFact: "🎯 Sem amor, até os maiores dons tornam-se barulho e orgulho!"
      }
    },

    86: {
      name: "Efésios: A Igreja Corpo de Cristo",
      challenge: "Pôs todas as coisas debaixo de seus pés e o deu por cabeça sobre a Igreja...",
      easy: {
        question: "Segundo Efésios, o que é a Igreja em relação a Cristo?",
        options: [
          "Seu templo",
          "Seu corpo",
          "Sua família",
          "Seu exército"
        ],
        correctAnswer: 1,
        hint: "Metáfora orgânica de unidade",
        funFact: "👤 Corpo de Cristo: cada cristão é um membro vital - interdependência!"
      },
      medium: {
        question: "Qual armadura Paulo descreve para o combate espiritual?",
        options: [
          "Armadura física",
          "Armadura de Deus: verdade, justiça, paz, fé, salvação, Palavra",
          "Armadura romana",
          "Proteção mágica"
        ],
        correctAnswer: 1,
        hint: "Seis peças de armadura espiritual",
        funFact: "⚔️ Combate espiritual com armas espirituais - estratégia divina de vitória!"
      },
      hard: {
        question: "Contra quem é nossa verdadeira luta segundo Paulo?",
        options: [
          "Contra homens maus",
          "Contra as potestades espirituais da maldade",
          "Contra governos",
          "Contra a pobreza"
        ],
        correctAnswer: 1,
        hint: "Trata-se de forças espirituais invisíveis",
        funFact: "👹 Combate cósmico: por trás dos conflitos humanos, guerra espiritual real!"
      }
    },

    87: {
      name: "Filipenses: A Alegria na Provação",
      challenge: "Regozijai-vos sempre no Senhor; outra vez digo: regozijai-vos!",
      easy: {
        question: "Qual sentimento Paulo encoraja apesar de sua prisão?",
        options: ["Resignação", "Alegria", "Raiva", "Tristeza"],
        correctAnswer: 1,
        hint: "Emoção surpreendente para um prisioneiro",
        funFact: "😊 Alegria 16 vezes em 4 capítulos - recorde de felicidade na prisão!"
      },
      medium: {
        question: "Segundo Filipenses 2, qual atitude Jesus adotou?",
        options: [
          "Impôs-se pela força",
          "Humilhou-se e abaixou-se até à morte",
          "Fugiu de suas responsabilidades",
          "Buscou a glória"
        ],
        correctAnswer: 1,
        hint: "Movimento descendente voluntário",
        funFact: "📉 Jesus: da igualdade com Deus à morte de cruz - amor extremo!"
      },
      hard: {
        question: "Como Paulo pode pregar a alegria na prisão?",
        options: [
          "Está fingindo",
          "A alegria cristã transcende as circunstâncias",
          "É masoquista",
          "Nega a realidade"
        ],
        correctAnswer: 1,
        hint: "Trata-se de uma alegria sobrenatural",
        funFact: "✨ Alegria = fruto do Espírito independente das circunstâncias - segredo divino!"
      }
    },

    88: {
      name: "As Epístolas Pastorais",
      challenge: "Combate o bom combate da fé, toma posse da vida eterna...",
      easy: {
        question: "A quem Paulo escreveu suas últimas cartas pastorais?",
        options: [
          "Aos Coríntios",
          "A Timóteo e Tito",
          "Aos Romanos",
          "Aos Gálatas"
        ],
        correctAnswer: 1,
        hint: "Seus filhos espirituais e colaboradores",
        funFact: "👨‍👦 Testamento espiritual: Paulo passa a tocha à próxima geração!"
      },
      medium: {
        question: "Qual conselho Paulo dá para escolher líderes da igreja?",
        options: [
          "Escolher os mais ricos",
          "Escolher segundo critérios morais e espirituais rigorosos",
          "Escolher os mais instruídos",
          "Escolher os mais populares"
        ],
        correctAnswer: 1,
        hint: "Qualificações morais acima de tudo",
        funFact: "⚖️ Padrões elevados para líderes: caráter antes da competência - prioridades divinas!"
      },
      hard: {
        question: "Qual herança Paulo deixa a Timóteo?",
        options: [
          "Bens materiais",
          "A fidelidade ao Evangelho e o ministério pastoral",
          "Um cargo político",
          "Uma escola teológica"
        ],
        correctAnswer: 1,
        hint: "Trata-se de herança espiritual",
        funFact: "📜 'Guarda o bom depósito' - transmissão fiel do Evangelho através dos séculos!"
      }
    },

    89: {
      name: "Hebreus: Jesus Sumo Sacerdote",
      challenge: "Temos um grande sumo sacerdote que atravessou os céus...",
      easy: {
        question: "Segundo Hebreus, quem é nosso grande sumo sacerdote?",
        options: ["Arão", "Moisés", "Jesus", "Melquisedeque"],
        correctAnswer: 2,
        hint: "O mediador perfeito entre Deus e os homens",
        funFact: "✝️ Jesus: Sacerdote e Vítima - sacrifício perfeito uma vez por todas!"
      },
      medium: {
        question: "Por que o sacerdócio de Jesus é superior ao de Arão?",
        options: [
          "É mais antigo",
          "É eterno segundo a ordem de Melquisedeque",
          "É mais rico",
          "É mais popular"
        ],
        correctAnswer: 1,
        hint: "Eternidade vs temporalidade",
        funFact: "♾️ Sacerdócio eterno: Jesus intercede perpetuamente por nós!"
      },
      hard: {
        question: "Como Hebreus apresenta a Nova Aliança?",
        options: [
          "Idêntica à antiga",
          "Superior e definitiva, escrita nos corações",
          "Temporária",
          "Opcional"
        ],
        correctAnswer: 1,
        hint: "Trata-se de cumprimento e superação",
        funFact: "📋 Nova Aliança: lei escrita nos corações, não na pedra!"
      }
    },

    90: {
      name: "Tiago: A Fé e as Obras",
      challenge: "A fé sem as obras é morta...",
      easy: {
        question: "Segundo Tiago, o que deve acompanhar a fé?",
        options: [
          "As palavras",
          "As obras",
          "As emoções",
          "O conhecimento"
        ],
        correctAnswer: 1,
        hint: "Manifestação prática da fé",
        funFact: "🌳 Fé = raiz, obras = frutos - árvore espiritual completa!"
      },
      medium: {
        question: "A que Tiago compara a língua?",
        options: [
          "A uma espada",
          "A um pequeno fogo que incendeia uma grande floresta",
          "A um instrumento musical",
          "A uma ferramenta"
        ],
        correctAnswer: 1,
        hint: "Pequeno membro mas grande poder destrutivo",
        funFact: "🔥 Língua: pequeno membro mas pode incendiar toda uma vida - cuidado!"
      },
      hard: {
        question: "Como conciliar Tiago e Paulo sobre fé/obras?",
        options: [
          "Contradizem-se",
          "Paulo fala de justificação, Tiago de santificação",
          "Um está errado",
          "Não há solução"
        ],
        correctAnswer: 1,
        hint: "Trata-se de dois aspectos complementares",
        funFact: "⚖️ Paulo: salvos pela fé / Tiago: fé provada pelas obras - harmonia perfeita!"
      }
    },

    91: {
      name: "Apocalipse: O Retorno do Rei",
      challenge: "Eis que venho em breve. Bem-aventurado aquele que guarda as palavras da profecia deste livro!",
      easy: {
        question: "A quantas igrejas João escreve no Apocalipse?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "O número da perfeição",
        funFact: "⛪ 7 igrejas da Ásia: espelho de todas as igrejas de todos os tempos!"
      },
      medium: {
        question: "Como termina a história segundo o Apocalipse?",
        options: [
          "Destruição total",
          "Novos céus e nova terra",
          "Retorno ao paraíso terrestre",
          "Fim de toda existência"
        ],
        correctAnswer: 1,
        hint: "Renovação completa da criação",
        funFact: "🌅 Não fim do mundo mas renovação total - esperança última!"
      },
      hard: {
        question: "Qual mensagem central o Apocalipse transmite aos perseguidos?",
        options: [
          "Rendam-se",
          "Cristo reina e triunfará definitivamente",
          "Fujam da perseguição",
          "Vinguem-se"
        ],
        correctAnswer: 1,
        hint: "Trata-se da esperança na vitória final",
        funFact: "👑 'Aquele que era, que é e que há de vir' - Senhor da história e do tempo!"
      }
    }
  }
};

export default chapter7Translations;
